import {
  ExistsElement,
  AddEvent,
  SetInputValue,
  GetInputValue,
  RemoveEvent,
  SetAttribute,
  RemoveAttribute,
} from "@/libs/cart/utility";

type _CloseDialog = ($dialog: JQuery<HTMLElement>, end: () => void) => void;

type _NextStep = (
  $dialog: JQuery<HTMLElement>,
  next: () => void,
  cancel: () => void
) => void;

export type _ShowDialog = (
  message: string,
  type: DialogType,
  success: () => void,
  cancel: () => void
) => void;

export type _InvokeDialogStepper = (
  isReserved: boolean,
  isBulkAction: boolean,
  itemNames: string[],
  menuYear: string,
  menuNum: string,
  success: any,
  cancel: any
) => void;

type _CreateDialogMessage = (itemNames?: string[]) => string;

export type _IsAcceptedDialogByMenuKey = (key: string) => boolean;

export type Template = (message: string, type: DialogType) => string;

export type MountedCartOrderDeliverySelect = (
  existsElement: ExistsElement,
  addEvent: AddEvent,
  getInputValue: GetInputValue,
  invokeChangeCartOrderDelivery: (event: JQuery.Event) => void,
  selector: string
) => () => void;

export type MountedCartOrderDeliveryButton = (
  existsElement: ExistsElement,
  addEvent: AddEvent,
  invokeChangeCartOrderDeliveryConfirmDialog: (event: JQuery.Event) => void,
  selector: string
) => () => void;

export type InvokeChangeCartOrderDelivery = (
  existsElement: ExistsElement,
  setInputValue: SetInputValue,
  getInputValue: GetInputValue,
  setAttribute: SetAttribute,
  removeAttribute: RemoveAttribute,
  close: _CloseDialog,
  next: _NextStep,
  isConfirmedSelector: string,
  dialogSelector: string
) => (event: JQuery.Event) => void;

export type InvokeChangeCartOrderDeliveryConfirmDialog = (
  existsElement: ExistsElement,
  addEvent: AddEvent,
  removeEvent: RemoveEvent,
  setAttribute: SetAttribute,
  removeAttribute: RemoveAttribute,
  invokeSubmitOrderCofirmForm: () => void,
  dialogSelector: string,
  confirmSelector: string,
  cancelSelector: string
) => (event: JQuery.Event) => void;

export type CloseDialog = (
  addEvent: AddEvent,
  removeEvent: RemoveEvent,
  selector: string
) => _CloseDialog;

export type NextStep = (
  addEvent: AddEvent,
  removeEvent: RemoveEvent,
  selector: string,
  cancelSelector: string,
  overlaySelector: string
) => _NextStep;

export type ShowDialog = (
  target: string,
  attributeName: string,
  template: Template,
  nextStep: _NextStep
) => _ShowDialog;

export type InvokeDialogStepper = (
  showDialog: _ShowDialog,
  createDialogMessage: _CreateDialogMessage,
  isAcceptedDialogByMenuKey: _IsAcceptedDialogByMenuKey,
  set: (value: string) => void,
  getInputValue: GetInputValue,
  beginnerSelector: string
) => _InvokeDialogStepper;

export type CreateDialogMessage = (
  defaultMessage: string,
  reservedMessage: string,
  sentenceEnd: string
) => _CreateDialogMessage;

export type HideAllDialog = (
  removeAttribute: RemoveAttribute,
  selector: string,
  selectSelector: string,
  restoreSelector: string,
  deleteSelector: string
) => () => void;

export type IsAcceptedDialogByMenuKey = (
  get: () => string[]
) => _IsAcceptedDialogByMenuKey;

export const dialogType = {
  default: "default",
  reserve: "reserve",
  error: "error",
} as const;
export type DialogType = typeof dialogType[keyof typeof dialogType];
